export default __webpack_public_path__ + "static/media/Gellix-Black.34a02909.woff";